import { CartItemInterface } from "~/modules/GraphQL/types";
import type { SelectedOption } from "~/modules/catalog/types";
import type { Price } from "~/modules/catalog/types";
import { magento } from "~/config/extensionsApi";
import { setSizeSwatch } from "~/modules/catalog/category/helpers";
import { MapConfigurableOption, MapProductVariant } from "~/modules/catalog/category/composables/useElasticSearch/types";

export const getUrlQuery = (variants: MapProductVariant[] = [], sku: string, configurableOpt: MapConfigurableOption[]) => {
  if (!variants || !Array.isArray(variants) || !configurableOpt) return "";

  const colorLabel = getColorLabel(variants, sku, configurableOpt);
  const sizeLabel = getSizeLabel(variants, sku, configurableOpt);
  if (colorLabel || sizeLabel) {
    const queryParams = [];
    if (colorLabel) {
      queryParams.push(`color=${encodeURIComponent(colorLabel)}`);
    }
    if (sizeLabel) {
      queryParams.push(`size=${encodeURIComponent(sizeLabel)}`);
    }
    if (queryParams.length > 0) {
      return `?${queryParams.join("&")}`;
    }
  }

  return "";
};

export const getVariantImage = (variants: MapProductVariant[] = [], sku: string) => {
  if (!variants || !Array.isArray(variants)) return "";

  const variant = variants.find((variant) => variant?.sku === sku);

  if (variant) {
    const thumbnailImage = variant?.thumbnail || variant?.image

    if (thumbnailImage) {
      return setSizeSwatch(thumbnailImage) || "";
    }
  }
};

export const getVariantName = (variants: MapProductVariant[] = [], sku: string) => {
  if (!variants || !Array.isArray(variants)) return "";

  const variant = variants.find((variant) => variant?.sku === sku);
  return variant?.name || "";
};

export const getColorLabel = (variants: MapProductVariant[] = [], sku: string, configurableOpt: MapConfigurableOption[]) => {
  if (!variants || !Array.isArray(variants) || !configurableOpt) return "";

  const variant = variants.find((variant) => variant?.sku === sku);
  const colorId = variant?.color;
  const colorOption = configurableOpt.find((opt) => opt.attribute_code === "color");
  const colorLabel = colorOption?.values.find((val) => val.value_index?.toString() === colorId.toString())?.label|| "";
  
  return colorLabel;
};

export const getSizeLabel = (variants: MapProductVariant[] = [], sku: string, configurableOpt: MapConfigurableOption[]) => {
  if (!variants || !Array.isArray(variants) || !configurableOpt) return "";

  const variant = variants.find((variant) => variant?.sku === sku);
  const sizeId = variant?.size;
  const sizeOption = configurableOpt.find((opt) => opt.attribute_code === "size");
  const sizeLabel = sizeOption?.values.find((val) => val.value_index?.toString() === sizeId.toString())?.label || "";

  return sizeLabel;
};

export const getBgColorValue = (variants: MapProductVariant[] = [], sku: string, configurableOpt: MapConfigurableOption[]) => {
  if (!variants || !Array.isArray(variants) || !sku) {
    return { "background-image": "#000" };
  }

  let color = { "background-image": "#000" };
  const variant = variants.find((variant) => variant?.sku === sku);

  const colorId = variant?.color;
  const colorOption = configurableOpt.find((opt) => opt.attribute_code === "color");

  const colorSwatch = colorOption?.values.find((val) => val.value_index?.toString() === colorId.toString())?.swatch_data?.value || "";
  const url = magento.urlSwatch + colorSwatch;

  if (colorSwatch) {
    color = {
      "background-image": `url("${url}")`,
    };
  }

  return color;
};

export const getPrice = (product: CartItemInterface): Price => {
  const regular = product.product?.price_range?.minimum_price?.regular_price?.value || 0;
  const final = product.product?.price_range?.minimum_price?.final_price?.value || 0;

  let percentage = 0;
  if (regular > 0 && final < regular && final > 0) {
    percentage = Math.round(((regular - final) / regular) * 100);
  }
  const priceValue = product.prices?.price?.value || 0;
  return {
    regular,
    final,
    percentage,
    priceValue,
  };
};

export const findMatchingSku = (selectedOption: SelectedOption, variants: MapProductVariant[]) => {
  return 
  // (
    // variants.find((variant) => {
    //   const attributes = variant.attributes;

    //   return Object.values(selectedOption).every((option) => attributes.some((attr) => attr.uid === option.uid));
    // })?.product.sku || null
  // );
};

export const checkColorOption = (product) => {
  if (product.configurable_options_map && product.configurable_options_map.length) {
    return product?.configurable_options_map.some((option) => option?.attribute_code === "color");
  }
  return false;
};

export const checkSizeOption = (product) => {
  if (product.configurable_options_map && product.configurable_options_map.length) {
    return product?.configurable_options_map.some((option) => option?.attribute_code === "size");
  }
  return false;
};
